import { createEvent } from "../EventObject";

import { ILogger } from "./ILogger";

export class InMemoryLoggerOutput {
    private readonly logLines: string[] = [];

    public onAppendLog = createEvent<[string[]]>();

    public getLogLines(): string[] {
        return this.logLines;
    }

    public write(message: string): void {
        this.logLines.push(message);
        this.onAppendLog.emit(message.split("\n"));
    }
}

export class InMemoryLogger implements ILogger {
    private readonly output: InMemoryLoggerOutput;
    private readonly prefix?: string;

    public constructor(output?: InMemoryLoggerOutput, prefix?: string) {
        this.output = output || new InMemoryLoggerOutput();
        this.prefix = prefix;
    }

    public log(message: string): void {
        this.writeMessage(this.getPrefixedMessage(message));
    }

    public warning(message: string): void {
        this.writeMessage(this.getPrefixedMessage(message));
    }

    public verbose(message: string): void {
        this.writeMessage(this.getPrefixedMessage(message));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public error(message: any | string | Error): void {
        this.writeMessage(this.getPrefixedMessage(`${message}`));
    }

    public withPrefix(prefix: string): ILogger {
        if (this.prefix == undefined) {
            return new InMemoryLogger(this.output, prefix);
        }
        return new InMemoryLogger(this.output, this.prefix + ":" + prefix);
    }

    private writeMessage(message: string): void {
        this.output.write(message);
    }

    private getPrefixedMessage(message: string | Error): string {
        const messageString = `${message}`;
        if (this.prefix == undefined) {
            return messageString;
        }
        return messageString
            .split("\n")
            .map(x => `[${this.prefix}] ${x}`)
            .join("\n");
    }
}
